module.exports = __webpack_public_path__ + "img/1d845a8.jpg";